import * as React from 'react'
import { SVGProps } from 'react'
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 247.789 247.789" {...props}>
    <path d="M223.779 122.895a6 6 0 0 0-6 6V235.79h-64.384v-67.102a6 6 0 0 0-6-6h-47a6 6 0 0 0-6 6v53.207a6 6 0 0 0 12 0v-47.207h35v61.102H30.01V88.929l93.884-75.239 96.132 77.04a6 6 0 1 0 7.504-9.364L127.646 1.318a5.998 5.998 0 0 0-7.504 0L20.258 81.366a5.999 5.999 0 0 0-2.248 4.682v155.741a6 6 0 0 0 6 6h199.769a6 6 0 0 0 6-6V128.895a6 6 0 0 0-6-6z" />
  </svg>
)
export default SvgHome
